import React, { useEffect, useState } from "react";
import "animate.css";
import "./QuantitySelector.css"; // Import custom styles

const QuantitySelector = ({ onQuantityChange, initialQuantity = undefined, showTitle = false, spacing = "py-2" }) => {
    const [quantity, setQuantity] = useState(initialQuantity ? initialQuantity : 1);
    const [animate, setAnimate] = useState(false);

    const triggerAnimation = () => {
        setAnimate(true);
        setTimeout(() => setAnimate(false), 300);
    };

    const increment = () => {
        const newQuantity = quantity + 1;
        setQuantity(newQuantity);
        onQuantityChange(newQuantity);
        triggerAnimation();
    };

    const decrement = () => {
        if (quantity > 1) {
            const newQuantity = quantity - 1;
            setQuantity(newQuantity);
            onQuantityChange(newQuantity);
            triggerAnimation();
        }
    };

    useEffect(() => {
        if (initialQuantity) {
            setQuantity(initialQuantity);
        }
    }, [initialQuantity]);

    return (
        <div>
            {showTitle && (
                <p className="quantity-selector-title">Cantidad</p>
            )}
            <div className="quantity-selector">
                <button className="quantity-button decrement" onClick={decrement}>-</button>
                <p className={`quantity-display m-0 ${spacing}`}>
                    <span className={`${animate ? "custom-pulse" : ""}`}>
                        {quantity}
                    </span>
                </p>
                <button className="quantity-button increment" onClick={increment}>+</button>
            </div>
        </div>
    );
};

export default QuantitySelector;
